import { z } from 'zod'
import { ChangeId, Id } from './common-schemas'
import { GarItem } from './gar-item'

export namespace AddressObjectDivision {
  export interface Data {
    /** @description Unique identifier of the record. PK field */
    readonly id: number

    /** @description Global unique identifier of the parent address object */
    readonly parentId: number

    /** @description Global unique identifier of the child address object */
    readonly childId: number

    /** @description ID of the transaction that changed the record */
    readonly changeId: number
  }
}

/** @description Address object division data. */
export class AddressObjectDivision extends GarItem<
  'AddressObjectDivision',
  AddressObjectDivision.Data
> {
  static readonly SCHEMA: GarItem.Schema<AddressObjectDivision.Data> = z
    .strictObject({
      ID: Id,

      PARENTID: z.coerce
        .number<string>()
        .int()
        .describe('Global unique identifier of the parent address object'),

      CHILDID: z.coerce
        .number<string>()
        .int()
        .describe('Global unique identifier of the child address object'),

      CHANGEID: ChangeId,
    })
    .transform<AddressObjectDivision.Data>(attributes => ({
      id: attributes.ID,
      parentId: attributes.PARENTID,
      childId: attributes.CHILDID,
      changeId: attributes.CHANGEID,
    }))

  readonly type = 'AddressObjectDivision'

  protected get schema() {
    return AddressObjectDivision.SCHEMA
  }
}
